import React, { Component } from 'react';
import FormControl from '@mui/material/FormControl';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import Input from '@mui/material/Input';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';

export default class TextSearchBlock extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchStr: !!this.props.searchStr ? this.props.searchStr : '',
            searchType: 0
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = name => evt => {
        this.setState({ [name]: evt.target.value });
    }

    render() {
        return (
            <div className="search-button-block">
                <FormControl>
                    <IconButton
                        className="search-button-menu-icon"
                        aria-label="menu"
                        onClick={(evt) => this.setState({ "anchorEl": evt.currentTarget })}
                        size="large">
                        <MenuIcon />
                    </IconButton>
                    <Menu
                        id="simple-menu"
                        anchorEl={this.state.anchorEl}
                        keepMounted
                        open={Boolean(this.state.anchorEl)}
                        onClose={this.handleClose}
                    >
                        <MenuItem value="0" onClick={() => { this.setState({ "anchorEl": null, "searchType": 0, "searchPlaceHolder": "Заголовок" }); this.props.handleChange('searchType')({ "target": { "value": 0 } }) }}>Заголовок</MenuItem>
                        <MenuItem value="1" onClick={() => { this.setState({ "anchorEl": null, "searchType": 1, "searchPlaceHolder": "Заголовок+Описание" }); this.props.handleChange('searchType')({ "target": { "value": 1 } }) }}>Заголовок+Описание</MenuItem>
                        <MenuItem value="2" onClick={() => { this.setState({ "anchorEl": null, "searchType": 2, "searchPlaceHolder": "Везде" }); this.props.handleChange('searchType')({ "target": { "value": 2 } }) }}>Везде</MenuItem>
                    </Menu>
                    <Input
                        id="adornment-search"
                        className="search-filter-input"
                        type='text'
                        value={this.state.searchStr}
                        placeholder={this.props.placeHolder}
                        onChange={(evt) => { this.handleChange('searchStr')(evt); }}
                        onKeyPress={(event) => (event.key === 'Enter') && this.props.startSearch(this.state.searchStr)}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="отмнеить поиск"
                                    onClick={() => { this.setState({'searchStr': ''}); this.props.startSearch(''); }}
                                    size="large">
                                    x
                                </IconButton>
                                <IconButton
                                    aria-label="начать поиск"
                                    onClick={() => { this.props.startSearch(this.state.searchStr); }}
                                    size="large">
                                    <SearchIcon />
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                </FormControl>
            </div>
        );
    }
}